"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBatchPutDeleteOperationParams = exports.DynamoDBBatchAction = void 0;
const tslib_1 = require("tslib");
const config_1 = tslib_1.__importDefault(require("@iotv/config"));
const dyn = config_1.default.aws.dynamoDB;
var DynamoDBBatchAction;
(function (DynamoDBBatchAction) {
    DynamoDBBatchAction["PUT"] = "PUT";
    DynamoDBBatchAction["DELETE"] = "DELETE";
})(DynamoDBBatchAction || (exports.DynamoDBBatchAction = DynamoDBBatchAction = {}));
const getBatchPutDeleteOperationParams = ({ items, action, tableNameOverride }) => {
    const resolvedTableName = tableNameOverride ?? dyn.tableName;
    items = items.reduce((a, c) => {
        if (!a.find((b) => b.sk === c.sk && b.pk === c.pk)) {
            a.push(c);
        }
        return a;
    }, []);
    const params = {
        RequestItems: {
            [resolvedTableName]: items.map((item) => {
                const request = {
                    [action === DynamoDBBatchAction.PUT ? 'PutRequest' : 'DeleteRequest']: action === DynamoDBBatchAction.PUT
                        ? {
                            Item: item,
                        }
                        : { Key: { sk: item.sk, pk: item.pk } },
                };
                return request;
            }),
        },
    };
    return params;
};
exports.getBatchPutDeleteOperationParams = getBatchPutDeleteOperationParams;
